import React from 'react';

import InputText, {IInputTextProps} from './InputText';
import {createSingleDomainValidator} from '../../lib/validation/validateDomain';

const InputDomain: React.FC<IInputTextProps> = (props) => {
    const rules = createSingleDomainValidator();

    return (
        <InputText
            rules={rules}
            {...props}
        />
    );
};

export default InputDomain;
